import script from "./checkplus_success.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkplus_success.vue?vue&type=script&setup=true&lang=ts"

import "./checkplus_success.vue?vue&type=style&index=0&id=3e396afc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e396afc"]])

export default __exports__